
export const environment = {

       production: false,
       projectName:'Dcafe',
     //apiURL: 'https://97o4pzvxvg.execute-api.ap-south-1.amazonaws.com/stg/', //prod-development
 //apiURL: 'https://voltaapi.stage.dctinc.net/', // stage
//apiURL:  'https://voltaapi.dcafecms.com/',
apiURL: 'https://masnapi.dcafecms.com/', // stage
//apiURL: 'https://wk9vn7kudd.execute-api.us-east-1.amazonaws.com/dev/',
// apiURL: 'http://localhost:3200/', //local-development

  apiURLEmbed: 'https://masn.dcafecms.com/',


    faviconImg:'../assets/images/favicon.ico',
    dashbordMisc:'misc/data',
    dashbordAnalytics:'/analytics/subscription',
    dashbordvideoTop:'/order',
    dashbordplatform:'/analytics/videos/platform',
    dashbordcontent:'/upcomingasset',
    dashbordorders:'/ordercount',
    dashbordusers:'/customercount',

    logoPath:'assets/images/dcafeLogo.svg',
    adminApiUrl:'admin',
    authApiUrl:'/auth',
    loginUrl:'/login',
    forgotPasswordUrl:'/forgotpassword',
    updatePasswordUrl:'/updatepassword',
    configurationApiUrl:'/configuration',
    getProductConfigurationUrl:'/productconfiguration',
    updateProductConfigurationUrl:'/productconfiguration/update',
    insertProductConfigurationUrl:'/productconfiguration',

    getCouponUrl:'/coupon',
    updateCouponUrl:'/coupon/update',
    deleteCouponUrl:'/coupon/delete',
    insertCouponUrl:'/coupon',


    getFlagUrl:'/flags',
    updateFlagUrl:'/flags/update',
    deleteFlagUrl:'/flags/delete',
    insertFlagUrl:'/flags',

    // getGeoZoneUrl:'/geozone',
    getProductTypeUrl:'/producttype',
    getGlobalProductTypeUrl:'/globalproducttype',
    updateProductTypeUrl:'/producttype/update',
    deleteProductTypeUrl:'/producttype/delete',
    insertProductTypeUrl:'/producttype',
    getPrimaryNavigationUrl:'/navigation',
    updatePrimaryNavigationUrl:'/navigation/update',
    deletePrimaryNavigationUrl:'/navigation/delete',
    insertPrimaryNavigationUrl:'/navigation',
    getGlobalPrimaryNavigationurl:'/globalprimarynavigation',
    getGlobalCertificationUrl:'/globalcertification',
    getGlobalGeozoneUrl:'/globalgeozone',
    globaltrailervideoUrl:'/globaltrailervideo',
    globalPageCategoryUrl:'/globalpagecategory',
    globalBlogUrl:'/globalblog',
    globalNewsUrl:'/globalnews',
    roleConfiguration:'/roleconfiguration',

    getAssetUrl:'/asset',
    updateAssetUrl:'/asset/update',
    deleteAssetUrl:'/asset/delete',
    deleteMultiple:'/asset/deleteMultiple',
    deleteMultipleAssetcategory:'/assetcategory/deleteMultiple',
    deleteMultipleAssetgroup:'/assetgroup/deleteMultiple',
    insertAssetUrl:'/asset',
    refreshUplynkUrl:'/channel/list',
    reconcillationUrl:'/reconcillation',
    deleteReconcillationUrl:'/reconcillation/delete',
    reconcillationVideoUrl:'/videos',

    getAssetGroupUrl:'/assetgroup',
    updateAssetGroupUrl:'/assetgroup/update',
    deleteAssetGroupUrl:'/assetgroup/delete',
    insertAssetGroupUrl:'/assetgroup',

    getAssetCategoryUrl:'/assetcategory',
    updateAssetCategoryUrl:'/assetcategory/update',
    deleteAssetCategoryUrl:'/assetcategory/delete',
    insertAssetCategoryUrl:'/assetcategory',


    getMrssQueueUrlList:'/mrss/queue/list',
    getMrssQueueUrl:'/mrss/queue',
    deleteMrssQueueUrl:'/mrss/queue/delete',
    insertMrssQueueUrl:'/mrss/queue/add',


    getClientUrl:'/clients',
    deleteClientUrl:'/clients/delete',
    insertClientUrl:'/clients',
    updateClientUrl:'/clients/update',



    getProfessionUrlList:'/profession/list',
    getProfessionUrl:'/profession',
    updateProfessionUrl:'/profession/update',
    deleteProfessionUrl:'/profession/delete',
    insertProfessionUrl:'/profession',


    getMrssPartnerUrl:'/mrss/partner/list',
    getMrssPartnerbyIdUrl:'/mrss/partner',
    updateMrssPartnerUrl:'/mrss/partner/edit',
    deleteMrssPartnerUrl:'/mrss/partner/delete',
    insertMrssPartnerUrl:'/mrss/partner/add',

    globaluplynkadserverUrl:'/globaluplynkadserver',
    globalliveeventUrl:'/globalliveevent',
    globalassetlibraryUrl:'/globalassetlibrary',
    globallibraryUrl:'/globallibrary',
    globalRoleUrl:'/globalrole',
    globallivevirtualchannelUrl:'/globallivevirtualchannel',
    globalCastUrl:'/globalcast',
    globalsponsorUrl:'/globalsponsor',
    getGlobalCharacterUrl:'/globalcharacter',
    getGlobalProfessionUrl:'/globalprofession',
    globalPageUrl:'/globalpage',


    getCastUrl:'/cast',
    updateCastUrl:'/cast/update',
    deleteCastUrl:'/cast/delete',
    insertCastUrl:'/cast',

    getCharacterUrl:'/character',
    updateCharacterUrl:'/character/update',
    deleteCharacterUrl:'/character/delete',
    insertCharacterUrl:'/character',


    getGeoZoneUrl:'/geozone',
    updateGeoZoneUrl:'/geozone/update',
    deleteGeoZoneUrl:'/geozone/delete',
    insertGeoZoneUrl:'/geozone',


    getCarouselUrl:'/carousel',
    updateCarouselUrl:'/carousel/update',
    deleteCarouselUrl:'/carousel/delete',
    insertCarouselUrl:'/carousel',


    getPageCategoryUrl:'/pagecategory',
    updatePageCategoryUrl:'/pagecategory/update',
    deletePageCategoryUrl:'/pagecategory/delete',
    insertPageCategoryUrl:'/pagecategory',

    updateMenuCategoryUrl:'/menucategory/update',
    insertMenuCategoryUrl:'/menucategory',
    getMenuCategoryUrl:'/menucategory',
    deleteMenuCategoryUrl:'/menucategory/delete',
    globalmenucategoryUrl:'/globalmenucategory',
    globalLanguageUrl:'/globallanguage',
    globalAssetGroupUrl:'/globalassetgroup',
    globalAssetCategoryUrl:'/globalassetcategory',

    getSubscriptionUrl:'/subscription',
    updateSubscriptionUrl:'/subscription/update',
    deleteSubscriptionUrl:'/subscription/delete',
    insertSubscriptionUrl:'/subscription',

    globalContinentListUrl: '/globalcontinent',
    globalCountryListUrl:'/globalcountry',
    globalCityListUrl:'/globalcity',
    globalStateListUrl:'/globalstate',
    globalDeviceTypeListUrl:'/globaldevicetype',
    globalLoginSourceListUrl:'/globalloginsource',
    globalReviewUrl:'/globalreview',
    globalclassificationUrl:'/globalclassification',

    globalGenreUrl:'/globalgenre',

    getGenreUrl:'/genre',
    updateGenreUrl:'/genre/update',
    deleteGenreUrl:'/genre/delete',
    insertGenreUrl:'/genre',

    insertUserUrl:'/user',
    getUserUrl:'/user',
    updateUserUrl:'/user/update',
    deleteUserUrl:'/user/delete',
    checkUrl:'/check',

    insertRoleUrl:'/role',
    getRoleUrl:'/role',
    updateRoleUrl:'/role/update',
    deleteRoleUrl:'/role/delete',

    insertRoleConfigurationUrl:'/roleconfiguration',
    getRoleConfigurationUrl:'/roleconfiguration',
    updateRoleConfigurationUrl:'/roleconfiguration/update',
    deleteRoleConfigurationUrl:'/roleconfiguration/delete',

    insertSponsorUrl:'/sponsor',
    getSponsorUrl:'/sponsor',
    updateSponsorUrl:'/sponsor/update',
    deleteSponsorUrl:'/sponsor/delete',

    insertReviewUrl:'/review',
    getReviewUrl:'/review',
    updateReviewUrl:'/review/update',
    deleteReviewUrl:'/review/delete',

    insertClassificationUrl:'/classification',
    getClassificationUrl:'/classification',
    updateClassificationUrl:'/classification/update',
    deleteClassificationUrl:'/classification/delete',

    insertUplynkadserverUrl: '/uplynkadserver',
    getUplynkadserverUrl: '/uplynkadserver',
    updateUplynkadserverUrl: '/uplynkadserver/update',
    deleteUplynkadserverUrl: '/uplynkadserver/delete',


    insertClientadserverUrl: '/clientadserver',
    getClientadserverUrl: '/clientadserver',
    updateClientadserverUrl: '/clientadserver/update',
    deleteClientadserverUrl: '/clientadserver/delete',


    insertFooterlinkUrl:'/footerlink',
    getFooterlinkUrl:'/footerlink',
    updateFooterlinkUrl:'/footerlink/update',
    deleteFooterlinkUrl:'/footerlink/delete',

    insertBlogsUrl:'/blog',
    getBlogsUrl:'/blog',
    updateBlogsUrl:'/blog/update',
    deleteBlogsUrl:'/blog/delete',

    insertCertificationUrl:'/certification',
    getCertificationUrl:'/certification',
    updateCertificationsUrl:'/certification/update',
    deleteCertificationUrl:'/certification/delete',
    getAllCertificationUrl:'/certification',

    insertBlogsCategoryUrl:'/blogcategory',
    getBlogsCategoryUrl:'/blogcategory',
    updateBlogsCategoryUrl:'/blogcategory/update',
    deleteBlogCategorysUrl:'/blogcategory/delete',

    insertNewsUrl:'/news',
    getNewsUrl:'/news',
    updateNewsUrl:'/news/update',
    deleteNewsUrl:'/news/delete',

    insertNewsCategoryUrl:'/newscategory',
    getNewsCategoryUrl:'/newscategory',
    updateNewsCategoryUrl:'/newscategory/update',
    deleteNewsCategoryUrl:'/newscategory/delete',

    bulkImportUrl:'/bulkupload/import',
    bulkExportUrl:'/bulkupload/export',

    deleteOrderUrl: '/order/delete',
    getOrderUrl: '/order',
    pausedUsersUrl: '/pause',
    pauseConfigUrl: '/pause/config',
    pauseUserUrl: '/pause/user',
    getSearchUrl: '/search',
    statusUpdateUrl :'/statusmanagement/update',
    getTracksUrl:'/track',

    region: '',
    identityPoolId: '',
    userPoolId: '',
    clientId: '',

    cognito_idp_endpoint: '',
    cognito_identity_endpoint: '',
    sts_endpoint: '',
    dynamodb_endpoint: '',

    //below are

    configurationPageTitle:'Settings',
    conPageSubTitle:'Product Configuration',
    conPageFlagSubTitle:'flags Configuration',
    conPagePTSubTitle:'Product Type',

    navigationPageTitle:'Navigation Setup',
    nPageSubTitle:'Primary Navigation',
    nMenuCatPageSubTitle:'Secondary Navigation',

    assetPageTitle:'Asset Management',
    aGroupSubTitle:'Asset Group (Series Setup)',
    acategorySubTitle:'Asset Category (Seasons Setup)',
    aSubTitle:'Asset (Episodes, Movies, Songs…)',
    aReconSubTitle:'Asset Reconcillition',
    aTracksSubTitle:'Tracks',

    mrssIngestionPageTitle:'Mrss Partner',
    mPartnerSubTitle:'Mrss Partner',
    mQueueSubTitle:'Mrss Queue',

    dashbordTitle:'Unified Dashboard',
    // dashbordSubTitle:'Google Analytics',
    dashbordSubTitle: '',
    pagePageTitle:'Page Management',
    pCategoryPageTitle:'Page Setup (Content Rails)',
    pCarouselPageTitle:'Carousel Setup',

    masterPageTitle:'Master',
    mGenresPageTitle:'Genre Setup',
    mLangPageTitle:'Language',
    mGeoZoneSubTitle:'Geo Zone Mapping',
    mCandCSubTitle:'Add Cast & Crew',
    mSponsorSubTitle:'Sponsor',
    mReviewsSubTitle:'Reviews',
    mCustomSubPage:'Create Custom Asset Groups',
    mUserverSubPage:'Uplynk Ad Server',

    mFooterSubPage:'Add Footer link',
    mCharacterSubPage:'Character',
    mBCSubPage:'Blogs Category',
    mBlogSubPage:'Blog',
    mNCSubPage:'News Category',
    mNSubTitle:'News',
    mPSubTitle:'Profession',
    mCertification:'Set Certification Rules',

    monetizationPageTitle:'Monetization',
    moneSubscriptionSubPage:'Subscription',
    moneOrderSubPage:'Order Details',

    userPageTitle:'User Management',
    userSubTitle:'User List',
    uRoleSubTitle:'Role Setup',



    //aws configuration

    awsConfiguration: {

      'accessKeyId':'AKIASYXB26NJKYQM2ZLR',
      'secretAccessKey':'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',
      'region':'us-west-1',
      'bucketName' : 'dcafe-content'
    },

    auth0Config: {
      'enable':true,
      'domainName': 'dcafe-world.us.auth0.com',
      'clientId': '9t1VC5XghXipwOXYftp6RNy9fJ9S7WSW',
      'redirectUrl': 'http://localhost:4200/authorize',
      'responseType': 'token id_token'
    }


};
